export default function initAbout() {
  if ($('.about').length > 0) {
    $('.about__select').on('click', function () {
      let id = $(this).attr('data-target')
      activateAboutTab(id)
    })
    $('.about__button').on('click', function () {
      let id = $(this).attr('data-target')
      activateAboutTab(id)
    })
  }
}

function activateAboutTab(id) {
  if (!$(`.about__info--${id}`).hasClass('about__info--active')) {
    $('.about__info--active').fadeOut(400, function () {
      $(this).removeClass('about__info--active')
      $('.about__select--active').removeClass('about__select--active')
      $('.about__company--active').removeClass('about__company--active')
      $(`.about__select--${id}`).addClass('about__select--active')
      $(`.about__company--${id}`).addClass('about__company--active')
      $(`.about__info--${id}`).fadeIn(400, function () {
        $(this).addClass('about__info--active')
      })
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/components/about.js